import { Component, OnInit, inject, Output, EventEmitter, ChangeDetectorRef, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { CommonModule } from '@angular/common';
import { Router, RouterModule } from '@angular/router';
import { LoginService } from '../../services/login.service';
import { SessionService } from '../../services/session.service';
import { CommonService } from '../../services/common.service';
import { AuthService } from '../../services/auth.service';

@Component({
  selector: 'app-header',
  standalone: true,
  imports: [CommonModule, RouterModule],
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit {
  private loginService = inject(LoginService);
  private sessionService = inject(SessionService);
  private common = inject(CommonService);
  private router = inject(Router);
  private cdr = inject(ChangeDetectorRef);
  private authService = inject(AuthService);
  private platformId = inject(PLATFORM_ID);

  @Output() onLogout = new EventEmitter<void>();

  userName: string = '';
  sessionModuleID: string | null = null;

  ngOnInit(): void {
    if (isPlatformBrowser(this.platformId)) {
      this.sessionModuleID = sessionStorage.getItem('session.module_id');
      this.getLoggedInUserDetails();
    }

    this.common.userChange$.subscribe((args: any) => {
      this.userName = args.user_name;
    });
  }

  getLoggedInUserDetails(): void {
    const userId = this.sessionService.get('user.id');
    if (userId) {
      this.loginService.API.GetLoggedInUserDetails(userId)
        .then((response: any) => {
          this.userName = response.name;
          this.cdr.detectChanges();
        })
        .catch((err: any) => {
          console.error('Error fetching user details:', err);
        });
    }
  }

  logout(): void {
    // If a parent component (like Dashboard) listens to this event, emit it to let them run custom teardowns.
    // Otherwise, default to the universal AuthService standard logout so other components (like Users) don't have to duplicate code!
    if (this.onLogout.observed || (this.onLogout as any).observers?.length > 0) {
      this.onLogout.emit();
    } else {
      this.authService.logout();
    }
  }

  closeApp(): void {
    this.sessionService.clear();
    window.close();
  }
}